import axios from "axios";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const forgotPassword = async (data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/forgot-password`, data);
        return { success: true, data: response.data };
    } catch (error) {
        if (error.response) {
            return { success: false, error: error.response.data.error };
        }
        return { success: false, error: "Something went wrong. Please try again." };
    }
};

export const resetPassword = async (data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/reset-password`, data);
        return { success: true, data: response.data };
    } catch (error) {
        if (error.response) {
            return { success: false, error: error.response.data.error };
        }
        return { success: false, error: "Something went wrong. Please try again." };
    }
};

export const validateToken = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/validate-token`, {
            params: { token }  // pass token as query parameter
        });
        return { success: true, data: response.data };
    } catch (error) {
        if (error.response) {
            return { success: false, error: error.response.data.error };
        }
        return { success: false, error: "Something went wrong. Please try again." };
    }
};

export const verifyEmail = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/verify-email`, {
            params: { token }  // pass token as query parameter
        });
        return { success: true, data: response.data };
    } catch (error) {
        if (error.response) {
            return { success: false, error: error.response.data.error };
        }
        return { success: false, error: "Something went wrong. Please try again." };
    }
};